<div class="mt-2">
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<table *ngIf="itemsToShow && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
		<thead>
			<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
				[displayOptions]="displayOptions" [post]="canManage ? 1 : 0">
			</tr>
		</thead>

		<tbody>
			<tr *ngFor="let item of itemsToShow">
				<td>
					<span [ngClass]="item.is_enabled === 0 ? 'text-decoration-line-through' : ''">
						{{ item.label }}
					</span>
				</td>
				<td class="cp-key  text-center">
					<span [ngClass]="item.is_enabled === 0 ? 'text-decoration-line-through' : ''">
						{{ item.billing_code }}
					</span>

					<span *ngIf="item.is_enabled === 0">
						- Disabled
					</span>

					<fa-icon [icon]="['fas', 'copy']" ngxClipboard (click)="copyToClipboardAlert(item.billing_code)"
						[cbContent]="item.billing_code" ngbTooltip="Copy to Clipboard"></fa-icon>
				</td>
				<td *ngIf="showAuthColumn" class="cp-key  text-center">
					<span *ngIf="showAuthCode">
						{{ item.auth_code }}
						<fa-icon [icon]="['fas', 'copy']" ngxClipboard (click)="copyToClipboardAlert('')" [cbContent]="item.auth_code"
							ngbTooltip="Copy to Clipboard"></fa-icon>
					</span>
					<span *ngIf="!showAuthCode">
						{{ ac.bullet.repeat(item.auth_code.length) }}
					</span>
				</td>
				<td class="text-center text-nowrap">
					<div *ngIf="item.added_on" [ngbTooltip]="item.added_on | date: ac.shortPageDateTimeFmt">
						{{ item.added_on | timeback }}
					</div>
				</td>
				<td class="text-center text-nowrap">
					<div *ngIf="item.edited_on" [ngbTooltip]="item.edited_on | date: ac.shortPageDateTimeFmt">
						{{ item.edited_on | timeback }}
					</div>
				</td>
				<td *ngIf="canManage">
					<button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="updateBillingCodePrep(item)"
						[disabled]="loading" ngbTooltip="Edit">
						<fa-icon [icon]="['fas', 'pencil']" size="sm"></fa-icon>
						<!-- Edit -->
					</button>
					<button type="button" class="btn btn-outline-warning btn-sm me-1" (click)="resetBillCodeAuthCodePrep(item)"
						[disabled]="loading" ngbTooltip="Reset">
						<fa-icon [icon]="['fas', 'arrows-rotate']" [spin]="loading" size="sm"></fa-icon>
						<!-- Reset -->
					</button>

					<button *ngIf="showDisable && item.is_enabled === 1" type="button" class="btn btn-outline-warning btn-sm"
						(click)="disableBillingCode(item)" [disabled]="loading" ngbTooltip="Disable">
						<fa-icon [icon]="['fas', 'ban']" size="sm"></fa-icon>
						<!-- Disable -->
					</button>

					<button *ngIf="showDisable && item.is_enabled === 0" type="button" class="btn btn-outline-success btn-sm"
						(click)="enableBillingCode(item)" [disabled]="loading" ngbTooltip="">
						<fa-icon [icon]="['fas', 'power-off']" size="sm"></fa-icon>
						Enable
					</button>
				</td>
			</tr>
		</tbody>
	</table>
	<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
		[centered]="false"></app-paging-bar>
</div>